import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";
import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import { ApiProvider } from "./api/clerk-auth-sync";
import { ThemeProvider, useTheme } from "./components/providers/theme-provider";
import { ModalProvider } from "./components/ui/dialog";
import { Toaster } from "./components/ui/toaster";
import "./index.css";
import { envVars } from "./lib/env-vars";
import { router } from "./router";

const InnerProviders: React.FC = () => {
  const { actualTheme } = useTheme();

  return (
    <ClerkProvider
      publishableKey={envVars.CLERK_PUBLISHABLE_KEY}
      appearance={actualTheme === "dark" ? dark as any : undefined}
    >
      <Toaster />
      <ApiProvider>
        <ModalProvider>
          <RouterProvider router={router} />
        </ModalProvider>
      </ApiProvider>
    </ClerkProvider>
  );
};

export const GlobalProviders: React.FC = () => {
  React.useEffect(() => {
    if (envVars.ENV === "prod" || envVars.ENV === "production") return;
    document.title = `${envVars.ENV} | Neon Blue`;
  }, []);

  return (
    <ThemeProvider defaultTheme="light">
      <InnerProviders />
    </ThemeProvider>
  );
};
